import type { Duel } from '@h2h/shared';
import { ChevronRight, Swords } from '../../components/ui/icons';
import { cn } from '../../lib/cn';

export function DuelRow({ duel, uid, onTap }: { duel: Duel; uid: string; onTap: () => void }) {
  const iAmChallenger = duel.challengerId === uid;
  const myScore = iAmChallenger ? duel.challengerScore : duel.opponentScore;
  const theirScore = iAmChallenger ? duel.opponentScore : duel.challengerScore;
  const resolved = duel.status === 'RESOLVED';
  const won = resolved && duel.winnerId === uid;
  const draw = resolved && duel.winnerId == null;

  return (
    <button
      type="button"
      onClick={onTap}
      className="tap flex w-full items-center gap-[13px] rounded-xl border border-black/5 bg-card p-4 text-left shadow-tile transition-transform active:scale-[0.99]"
    >
      <div
        className={cn(
          'grid h-[42px] w-[42px] shrink-0 place-items-center rounded-tile',
          resolved ? (won ? 'bg-accent-wash text-accent-ink' : draw ? 'bg-fill text-ink2' : 'bg-danger/10 text-danger') : 'bg-[#5B6EE1]/14 text-[#4453B8]'
        )}
      >
        <Swords width={20} height={20} strokeWidth={2} />
      </div>
      <div className="min-w-0 flex-1">
        <div className="text-[14px] font-bold tracking-snug text-ink">
          {resolved ? (won ? 'You won the duel' : draw ? 'Duel drawn' : 'Duel lost') : 'Duel in play'}
        </div>
        <div className="text-[12px] font-medium text-ink2">
          {resolved ? `${myScore ?? 0}–${theirScore ?? 0}` : 'Most points this round wins'}
        </div>
      </div>
      <ChevronRight width={18} height={18} strokeWidth={2.2} className="text-ink3" />
    </button>
  );
}
